export const getItem = (key: string) => {
  return safeGetItemFromLocalStorage(key);
};

export const getItemAsObject = (key: string) => {
  const currentStr = getItem(key);
  return currentStr ? JSON.parse(currentStr) : undefined;
};

export const setItem = (key: string, val: any) => {
  const stringVal = typeof val === "object" ? JSON.stringify(val) : val;
  safeSaveItemToLocalStorage(key, stringVal);
};

const safeSaveItemToLocalStorage = (key: string, val: string) => {
  try {
    return localStorage.setItem(key, val);
  } catch {}
};

const safeGetItemFromLocalStorage = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch {}
};
